import { useAuthStore } from '@/store/authStore';

export interface MobileFeatures {
  canBrowse: boolean;
  canUpload: boolean;
  canCapture: boolean;
  canDownload: boolean;
  canViewMarkup: boolean;
}

const ROLE_PRESETS: Record<string, MobileFeatures> = {
  FIELD_WORKER: {
    canBrowse: true,
    canUpload: true,
    canCapture: true,
    canDownload: true,
    canViewMarkup: false,
  },
  ESTIMATOR: {
    canBrowse: true,
    canUpload: true,
    canCapture: true,
    canDownload: true,
    canViewMarkup: true,
  },
  PROJECT_MANAGER: {
    canBrowse: true,
    canUpload: false,
    canCapture: false,
    canDownload: true,
    canViewMarkup: true,
  },
};

export function useMobileRole(): MobileFeatures {
  const user = useAuthStore((state) => state.user);
  const role = user?.role?.is_system ? 'PROJECT_MANAGER' : 'ESTIMATOR';
  return ROLE_PRESETS[role] ?? ROLE_PRESETS.ESTIMATOR;
}
